import { useMutation } from "@tanstack/react-query";
import { ServerInferRequest } from "@ts-rest/core";
import { integrationAccountContract } from "../common/contracts/integration-account.contract";
import { getBackendAPIClient } from "../lib/backendAPIClient";
import { IntegrationAccount } from "../common/types/integrationAccount";
import { IntegrationAccountDto } from "../common/dto/financialAccount/integration-account.dto";

const integrationAccountContractClient = getBackendAPIClient(
    integrationAccountContract,
);

interface UseIntegrationAccountUpdateMutationParams {
    integrationAccount: IntegrationAccount;
    onMutate?: (body: IntegrationAccountUpdateBody) => void;
    onSuccess?: (updatedAccount: IntegrationAccount) => void;
    onError?: (previousAccount: IntegrationAccount) => void;
}

export type IntegrationAccountUpdateBody = ServerInferRequest<
    typeof integrationAccountContract.updateIntegrationAccount
>["body"];

export function useIntegrationAccountUpdateMutation({
    integrationAccount,
    onMutate,
    onSuccess,
    onError,
}: UseIntegrationAccountUpdateMutationParams) {
    return useMutation({
        mutationFn: async (body: IntegrationAccountUpdateBody) => {
            const response =
                await integrationAccountContractClient.updateIntegrationAccount(
                    {
                        params: {
                            id: integrationAccount.id,
                        },
                        body,
                    },
                );

            return IntegrationAccountDto.deserialize(response.body);
        },
        onMutate: (body) => {
            onMutate?.(body);

            return integrationAccount;
        },
        onSuccess,
        onError: (_1, _2, previousAccount) => {
            if (previousAccount) {
                onError?.(previousAccount);
            }
        },
    });
}
